import { gql } from '@apollo/client';

export const CORE_COMPANY_FIELDS = gql`
    fragment CoreCompanyFields on Company {
        id
        recordId
        name
        joinDate
        phone
        website
        twitterUrl
        linkedinUrl
        logoUrl
        description
        status
        addresses(purpose: [MAIN]) {
            country
            address
            address2
            address3
            city
            stateProvince
            zip
            purpose
            preferredBilling
            preferredMailing
        }
        primaryBusinessType {
            code
            name
        }
        secondaryBusinessTypes {
            code
            name
        }
        events {
            recordId
            code
            title
            url
            beginsAt
            endsAt
            image
            location {
                purpose
                address
                city
                stateProvince
                country
            }
        }
    }
`;
